module.exports = __webpack_public_path__ + "img/ossetia.c530587f.png";